export const getEventParticipants = (projectId, search) =>
  fetch(`/projects/${projectId}/contacts/participants?q=${search}`)
    .then(response => response.json())
    .then(data => {
      return {
        ...data,
        participants: data.participants.map(participant => ({
          ...participant,
          role_label: (data.roles[participant.role_code] && data.roles[participant.role_code].label) || participant.role_code
        }))
      }
    });
